import React, { useState } from "react";
import classes from "../customer.module.css";
import Box from "@mui/material/Box";
import {
  Button,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useDispatch, useSelector } from "react-redux";
import TeamsListItem from "./TeamsListItem";
import AddTeamMemberModal from "./AddTeamMemberModal";
import {
  OppositeSortArrawBtnIcons,
  SortArrawBtnIcons,
} from "../../../../Components/Icons/Icons";
import { handleSortClick } from "../../../../Utilities/commonfunctions";

function TeamRow({ team, expanded, onToggle, members, loading, sortBy }) {
  const dispatch = useDispatch();
  const { invoice } = useSelector((state) => state.filter);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const memberCount = expanded && members
    ? members.length
    : team?.team_members?.length || 0;

  return (
    <React.Fragment>
      <TableRow
        className={classes.table_bg1}
        style={{
          cursor: "pointer",
          borderBottom: !expanded ? "20px solid  #f4f5f570" : "none",
        }}
        onClick={onToggle}
      >
        <TableCell style={{ minWidth: "0px", padding: 0 }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onToggle();
            }}
          >
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ textTransform: "capitalize" }}>
          {team?.team_name}
        </TableCell>
        <TableCell>{memberCount}</TableCell>
      </TableRow>
      <TableRow
        className={`${classes.table_bg1} ${classes.childRow}`}
        style={{
          borderBottom: expanded ? "20px solid  #f4f5f570" : "none",
          display: expanded ? "table-row" : "none",
        }}
      >
        <TableCell colSpan={3} className={classes.ColspanMainTd}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: 8,
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setShowAddMemberModal(true)}
                >
                  Add Member
                </Button>
              </div>
              {showAddMemberModal && (
                <AddTeamMemberModal
                  teamId={team._id}
                  sort={sortBy}
                  active={invoice}
                  handleClose={() => setShowAddMemberModal(false)}
                />
              )}
              <Table
                size="small"
                aria-label="team members"
                className={classes.SubTable}
              >
                <TableHead>
                  <TableRow className={classes.TableSubRow}>
                    <TableCell>
                      <div className={classes.tableHEadercelldiv}>
                        <span> Team Member </span>
                        <span
                          onClick={() =>
                            handleSortClick(dispatch, sortBy, "name")
                          }
                        >
                          {sortBy?.includes("desc") &&
                          sortBy?.includes("name") ? (
                            <OppositeSortArrawBtnIcons />
                          ) : (
                            <SortArrawBtnIcons />
                          )}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>Mobile Number</TableCell>
                    <TableCell>
                      <div className={classes.tableHEadercelldiv}>
                        <span> Registered On </span>
                        <span
                          onClick={() =>
                            handleSortClick(dispatch, sortBy, "createdAt")
                          }
                        >
                          {sortBy?.includes("desc") &&
                          sortBy?.includes("createdAt") ? (
                            <OppositeSortArrawBtnIcons />
                          ) : (
                            <SortArrawBtnIcons />
                          )}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>Locations</TableCell>
                    <TableCell>
                      <div className={classes.tableHEadercelldiv}>
                        <span> Status </span>
                        <span
                          onClick={() =>
                            handleSortClick(dispatch, sortBy, "is_active")
                          }
                        >
                          {sortBy?.includes("desc") &&
                          sortBy?.includes("is_active") ? (
                            <OppositeSortArrawBtnIcons />
                          ) : (
                            <SortArrawBtnIcons />
                          )}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell style={{ minWidth: 100 }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : members && members.length > 0 ? (
                    members.map((item, index) => (
                      <TeamsListItem
                        key={index}
                        employee={item}
                        team_id={team._id}
                      />
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center">
                        No Data Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default TeamRow;
